export default __webpack_public_path__ + "static/media/maintainanceLogo.b4964959.svg";